import { IBackendJiraConfig } from '~/domain/IBackendConfig';
import { IJiraConfig, IJiraConfigFields } from '~/domain/IJiraConfig';
import { IJiraCreateMeta } from '~/domain/IJiraCreateMeta';

import { getFullName, mapField } from './fields';

export const mapConfig = (jiraCreateMeta: IJiraCreateMeta, jiraProjectConfig: IBackendJiraConfig): IJiraConfig => {
  const fields = {} as IJiraConfigFields;
  const config: IJiraConfig = { issueTypeId: '', fields };

  const { 
    projectKey: jiraProjectKey, 
    prefix: jiraPrefix,
    issueTypeName: jiraIssueTypeName,
    requestTypeName: jiraRequestTypeName,
    fields: {
      addressableRegion: jiraAddressableRegion,
      addressableVersion: jiraAddressableVersion,
      affectedEIMs: jiraAffectedEIMs,
      buildVersion: jiraBuildVersion,
      fbItemLink: jiraFbItemLink,
      issueCategory: jiraIssueCategory,
      productionRound: jiraProductionRound,
      raisedRound: jiraRaisedRound,
      reviewDueDate: jiraReviewDueDate,
      reviewRegion: jiraReviewRegion,
      reviewSubmarket: jiraReviewSubmarket,
      vehicleModel: jiraVehicleModel,
      vehicleYear: jiraVehicleYear,
    },
  } = jiraProjectConfig;

  if (jiraCreateMeta) {
    const project = jiraCreateMeta.projects.find(project => project.key === jiraProjectKey);
    if (project) {
      const issueType = project.issuetypes.find(issueType => issueType.name === getFullName(jiraIssueTypeName, jiraPrefix));
      if (issueType) {
        config.issueTypeId = issueType.id;
        const issueFields = Object.values(issueType.fields);
        
        fields.addressableRegion = mapField(issueFields, jiraAddressableRegion, jiraPrefix);
        fields.addressableVersion = mapField(issueFields, jiraAddressableVersion, jiraPrefix);
        fields.affectedEims = mapField(issueFields, jiraAffectedEIMs, jiraPrefix);
        fields.buildVersion = mapField(issueFields, jiraBuildVersion, jiraPrefix);
        fields.feedbackItemLink = mapField(issueFields, jiraFbItemLink, jiraPrefix);
        fields.issueCategory = mapField(issueFields, jiraIssueCategory, jiraPrefix);
        fields.raisedRound = mapField(issueFields, jiraRaisedRound, jiraPrefix);
        fields.vehicleModel = mapField(issueFields, jiraVehicleModel, jiraPrefix);
        fields.vehicleYear = mapField(issueFields, jiraVehicleYear, jiraPrefix);
      }

      const requestType = project.issuetypes.find(issueType => issueType.name === getFullName(jiraRequestTypeName, jiraPrefix));
      if (requestType) {
        const requestFields = Object.values(requestType.fields);
        fields.buildVersion = fields.buildVersion || mapField(requestFields, jiraBuildVersion, jiraPrefix);
        fields.productionRound = mapField(requestFields, jiraProductionRound, jiraPrefix);
        fields.reviewDueDate = mapField(requestFields, jiraReviewDueDate, jiraPrefix);
        fields.reviewRegion = mapField(requestFields, jiraReviewRegion, jiraPrefix);
        fields.reviewSubmarket = mapField(requestFields, jiraReviewSubmarket, jiraPrefix);
      }
    }
  }
  return config;
}
